import { getAccountFeatureFlags } from "@/services/AccountService"

export const fetchAccountFeatureFlags = async ({ commit }, accountKey) => {
  const { flags } = await getAccountFeatureFlags(accountKey)

  commit("setAccountFlags", flags)

  return flags
}
